// Firebase web config is public by design — these values ship in the client bundle
// and are visible to any user in DevTools. Real security comes from Firebase Security
// Rules and the Authorized Domains list in the Firebase Console.
// See: https://firebase.google.com/docs/projects/api-keys
const firebaseConfig = {
  apiKey: "AIzaSyC-3MnzKF3jhcX2mIX4afY19kflUt6LSu8",
  authDomain: "gigmi-342312.firebaseapp.com",
  projectId: "gigmi-342312",
  storageBucket: "gigmi-342312.appspot.com",
  messagingSenderId: "790797099459",
  appId: "1:790797099459:web:3aa210ea99988d369b1d76",
  measurementId: "G-T6BQV9DBR4",
};

export default firebaseConfig;
